<template>
  <main>
    <!-- <section class="topnav navbar navbar-expand-md navbar-dark nav_color"
      style="width: 100%;background: #000;opacity: 0.9;padding: 0px;position: fixed;z-index: 9999;height: 2.5rem;">
      <div class="container">
        <button class="navbar-toggler collapsed" type="button" data-toggle="collapse"
          data-target="#productsNnavbarColor02" aria-controls="productsNnavbarColor02" aria-expanded="false"
          aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="navbar-collapse collapse" id="productsNnavbarColor02">
          <ul class="navbar-nav sub_navbar_nav row" style="display: contents;">
            <li class="nav-item  col">
              <router-link class="nav-link" to="/vipCenter/JoinVIP"
                :class="{ active: $route.path === '/vipCenter/JoinVIP' }">Join VIP</router-link>
            </li>
            <li class="nav-item col">
              <router-link class="nav-link" to="/vipCenter/Favorite"
                :class="{ active: $route.path === '/vipCenter/Favorite' }">Favorite</router-link>
            </li>
            <li class="nav-item col">
              <router-link class="nav-link" to="/vipCenter/NewProduct"
                :class="{ active: $route.path === '/vipCenter/NewProduct' }">New Product</router-link>
            </li>
          </ul>
        </div>
      </div>
    </section> -->
    <!-- <NavigationCard image="/assets/img/VIP/navigation.png" topUrl="" topUrlType="video" title="SANMAK VIP CENTER" /> -->
    <NavigationCard image="/assets/img/VIP/navigation.png" topUrl="../../../assets/img/TopFirst/VIPTop.mp4" topUrlType="video"  />
    <div class=" page_content">
      <RouteNav></RouteNav>
      <router-view :key="$route.fullPath"></router-view>
      </div>
  </main>
</template>

<script>
// import NavigationCard from '@/components/common/NavigationCard.vue';
import NavigationCard from '@/components/common/TopVideo.vue';
import RouteNav from '@/components/common/RouteNav.vue';
export default {
  name: 'VIPCenter',
  components: {
    NavigationCard,
    RouteNav,
  },
};
</script>

<style scoped>
@import '../../assets/css/main.css';

</style>
